module.exports = __webpack_public_path__ + "static/media/1.3_manual.52e2ccbd.png";